import { includeInCsp } from '../../utils/HeaderContext';
import * as style from './richText.module.css';

export interface PodcastProps {
    _type: 'podcast';
    _key: string;
    episodeId: string;
    show: string;
    title: string;
}

export const podcastGroq = /* groq */ `{
    _type,
    episodeId,
    show,
    title
}`;

const bgColor = '092529'; //@color-swamp
const accentColor = 'ffffff';
const fontFamily = 'Roboto';
const fontSrc = encodeURIComponent('https://fonts.googleapis.com/css?family=Roboto');

export function Podcast({ episodeId, show, title }: PodcastProps) {
    includeInCsp('frame-src', 'https://embed.acast.com/');

    return (
        <div className={style.podcast}>
            <iframe
                title={title}
                src={`https://embed.acast.com/${show}/${episodeId}?accentColor=${accentColor}&bgColor=${bgColor}&font-family=${fontFamily}&font-src=${fontSrc}`}
            />
        </div>
    );
}
